import { useContext, useMemo } from 'react';
import { ParentContext } from '../ParentContext';

export const useViewListData = ({ docName, docKey }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { eventInfo_state } = states
  const { appDataDocuments } = eventInfo_state ?? {}
  const appDataDocument = appDataDocuments?.[docName]

  const data = useMemo(() => {
    return docKey ? appDataDocument?.[docKey] : appDataDocument
  }, [docName, docKey])

  return data
}
